import React from "react";
import { Link } from "react-router-dom";
import cars from "../data/cars";
import { useLanguage } from "../context/LanguageContext";

function Home() {
  const { language } = useLanguage();

  const featuredCarIds = [1, 2, 3, 4, 6, 19];

  const featuredCars = featuredCarIds
    .map((id) => cars.find((car) => car.id === id))
    .filter(Boolean);

  const whatsappNumber = "355697555461";

  const translations = {
    en: {
      heroLabel: "Premium Car Rental in Albania",
      heroTitle1: "Drive Albania",
      heroTitle2: "your way.",
      heroDescription:
        "From premium luxury vehicles to practical everyday cars, find the right vehicle for your journey across Albania.",
      checkAvailability: "Check Availability",
      exploreCars: "Explore Our Cars",

      vehicles: "Vehicles",
      support: "Customer support",
      starting: "Starting per day",

      featured: "FEATURED",
      perDay: "/ day",

      fleetLabel: "OUR FLEET",
      fleetTitle: "Choose how you want to travel.",
      fleetDescription:
        "Luxury, comfort or economy. Browse our fleet and choose the car that fits your trip.",
      car: "Car",
      viewCar: "View Car",
      viewAll: "View All 20 Cars →",

      whyLabel: "WHY AUTORENT ALBANIA",
      whyTitle: "Simple from search to road.",

      step1Title: "Choose your dates",
      step1Text:
        "Enter your pickup and return dates to instantly see which cars are available.",

      step2Title: "Pick your car",
      step2Text:
        "Compare our luxury and economic vehicles with clear daily prices.",

      step3Title: "Send your request",
      step3Text:
        "Submit your details and your booking request is sent directly to us.",

      step4Title: "Confirm on WhatsApp",
      step4Text:
        "Continue directly on WhatsApp with AutoRent Albania to confirm your reservation.",

      travelLabel: "TRAVEL WITH CONFIDENCE",
      travelTitle1: "Your journey.",
      travelTitle2: "Your schedule.",
      travelDescription:
        "Whether you are arriving for a holiday, business trip or exploring Albania by road, our fleet gives you the freedom to travel your way.",
      findCar: "Find an Available Car",

      benefitVehicles: "20 Vehicles",
      benefitVehiclesText:
        "A varied fleet for different trips.",

      benefitSupport: "24/7 Support",
      benefitSupportText:
        "Contact us whenever you need assistance.",

      benefitPricing: "Clear Pricing",
      benefitPricingText:
        "See the daily price before requesting.",

      benefitBooking: "Fast Booking",
      benefitBookingText:
        "Check availability online in seconds.",

      readyLabel: "READY TO DRIVE?",
      readyTitle: "Find your car and explore Albania.",
      readyDescription:
        "Check availability for your travel dates or contact us directly for help choosing the right vehicle.",
      whatsapp: "WhatsApp Us",
    },

    sq: {
      heroLabel: "Makina me Qira në Shqipëri",
      heroTitle1: "Udhëto në Shqipëri",
      heroTitle2: "sipas mënyrës tënde.",
      heroDescription:
        "Nga makinat luksoze premium deri te makinat praktike për përdorim të përditshëm, zgjidh makinën e duhur për udhëtimin tënd në Shqipëri.",
      checkAvailability: "Kontrollo Disponueshmërinë",
      exploreCars: "Shiko Makinat",

      vehicles: "Makina",
      support: "Mbështetje për klientët",
      starting: "Duke filluar nga",

      featured: "E PËRZGJEDHUR",
      perDay: "/ ditë",

      fleetLabel: "FLOTA JONË",
      fleetTitle: "Zgjidh si dëshiron të udhëtosh.",
      fleetDescription:
        "Luks, rehati apo ekonomi. Shiko flotën tonë dhe zgjidh makinën që i përshtatet udhëtimit tënd.",
      car: "Makina",
      viewCar: "Shiko Makinën",
      viewAll: "Shiko të Gjitha 20 Makinat →",

      whyLabel: "PSE AUTORENT ALBANIA",
      whyTitle: "E thjeshtë, nga kërkimi deri në rrugë.",

      step1Title: "Zgjidh datat",
      step1Text:
        "Vendos datën dhe orën e marrjes dhe kthimit për të parë menjëherë makinat e disponueshme.",

      step2Title: "Zgjidh makinën",
      step2Text:
        "Krahaso makinat tona luksoze dhe ekonomike me çmime të qarta ditore.",

      step3Title: "Dërgo kërkesën",
      step3Text:
        "Plotëso të dhënat e tua dhe dërgo kërkesën e rezervimit direkt tek ne.",

      step4Title: "Konfirmo në WhatsApp",
      step4Text:
        "Vazhdo direkt në WhatsApp me AutoRent Albania për të konfirmuar rezervimin.",

      travelLabel: "UDHËTO ME SIGURI",
      travelTitle1: "Udhëtimi yt.",
      travelTitle2: "Orari yt.",
      travelDescription:
        "Qoftë për pushime, udhëtim pune apo për të eksploruar Shqipërinë me makinë, flota jonë të jep lirinë të udhëtosh sipas mënyrës tënde.",
      findCar: "Gjej një Makinë të Disponueshme",

      benefitVehicles: "20 Makina",
      benefitVehiclesText:
        "Një flotë e larmishme për udhëtime të ndryshme.",

      benefitSupport: "Mbështetje 24/7",
      benefitSupportText:
        "Na kontakto sa herë që ke nevojë për ndihmë.",

      benefitPricing: "Çmime të Qarta",
      benefitPricingText:
        "Shiko çmimin ditor përpara se të dërgosh kërkesën.",

      benefitBooking: "Rezervim i Shpejtë",
      benefitBookingText:
        "Kontrollo disponueshmërinë online brenda pak sekondash.",

      readyLabel: "GATI PËR UDHËTIM?",
      readyTitle: "Gjej makinën tënde dhe eksploro Shqipërinë.",
      readyDescription:
        "Kontrollo disponueshmërinë për datat e udhëtimit ose na kontakto direkt për të zgjedhur makinën e duhur.",
      whatsapp: "Na shkruaj në WhatsApp",
    },
  };

  const t = translations[language];

  const sectionStyle = {
    width: "min(1200px, calc(100% - 40px))",
    margin: "0 auto",
  };

  return (
    <div>
      {/* HERO */}
      <section
        style={{
          background: "#111317",
          color: "#ffffff",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            ...sectionStyle,
            minHeight: "620px",
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            gap: "50px",
            paddingTop: "65px",
            paddingBottom: "65px",
          }}
        >
          <div
            style={{
              flex: "1 1 430px",
              position: "relative",
              zIndex: 2,
            }}
          >
            <p
              style={{
                margin: "0 0 18px",
                color: "#a8adb5",
                fontSize: "12px",
                fontWeight: "900",
                textTransform: "uppercase",
                letterSpacing: "2.5px",
              }}
            >
              {t.heroLabel}
            </p>

            <h1
              style={{
                margin: "0 0 24px",
                maxWidth: "700px",
                fontSize: "clamp(48px, 7vw, 86px)",
                lineHeight: "0.95",
                letterSpacing: "-4px",
                fontWeight: "900",
              }}
            >
              {t.heroTitle1}
              <br />
              {t.heroTitle2}
            </h1>

            <p
              style={{
                margin: "0 0 32px",
                maxWidth: "580px",
                color: "#a8adb5",
                fontSize: "17px",
                lineHeight: "1.75",
              }}
            >
              {t.heroDescription}
            </p>

            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "12px",
              }}
            >
              <Link
                to="/booking"
                style={{
                  padding: "15px 22px",
                  borderRadius: "13px",
                  background: "#ffffff",
                  color: "#111317",
                  fontWeight: "900",
                }}
              >
                {t.checkAvailability}
              </Link>

              <Link
                to="/cars"
                style={{
                  padding: "15px 22px",
                  borderRadius: "13px",
                  border: "1px solid rgba(255,255,255,0.16)",
                  color: "#ffffff",
                  fontWeight: "900",
                }}
              >
                {t.exploreCars}
              </Link>
            </div>

            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "34px",
                marginTop: "48px",
              }}
            >
              <div>
                <strong
                  style={{
                    display: "block",
                    fontSize: "26px",
                  }}
                >
                  20
                </strong>

                <span
                  style={{
                    color: "#8f949c",
                    fontSize: "13px",
                  }}
                >
                  {t.vehicles}
                </span>
              </div>

              <div>
                <strong
                  style={{
                    display: "block",
                    fontSize: "26px",
                  }}
                >
                  24/7
                </strong>

                <span
                  style={{
                    color: "#8f949c",
                    fontSize: "13px",
                  }}
                >
                  {t.support}
                </span>
              </div>

              <div>
                <strong
                  style={{
                    display: "block",
                    fontSize: "26px",
                  }}
                >
                  €25
                </strong>

                <span
                  style={{
                    color: "#8f949c",
                    fontSize: "13px",
                  }}
                >
                  {t.starting}
                </span>
              </div>
            </div>
          </div>

          {/* HERO IMAGE */}
          <div
            style={{
              flex: "1 1 470px",
              minWidth: 0,
            }}
          >
            <div
              style={{
                position: "relative",
                borderRadius: "28px",
                overflow: "hidden",
                minHeight: "460px",
                background: "#202329",
              }}
            >
              <img
                src="/images/cars/a8.jpg"
                alt="Audi A8 L - AutoRent Albania"
                style={{
                  width: "100%",
                  height: "460px",
                  objectFit: "cover",
                }}
              />

              <div
                style={{
                  position: "absolute",
                  left: 0,
                  right: 0,
                  bottom: 0,
                  padding: "80px 24px 24px",
                  background:
                    "linear-gradient(transparent, rgba(0,0,0,0.88))",
                }}
              >
                <p
                  style={{
                    margin: "0 0 5px",
                    color: "#bfc2c7",
                    fontSize: "12px",
                    fontWeight: "800",
                  }}
                >
                  {t.featured}
                </p>

                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-end",
                    justifyContent: "space-between",
                    gap: "20px",
                  }}
                >
                  <div>
                    <strong
                      style={{
                        display: "block",
                        fontSize: "24px",
                      }}
                    >
                      Audi A8 L
                    </strong>

                    <span
                      style={{
                        color: "#bfc2c7",
                        fontSize: "13px",
                      }}
                    >
                      3.0 Diesel • Automat
                    </span>
                  </div>

                  <strong
                    style={{
                      fontSize: "24px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    €130
                    <span
                      style={{
                        fontSize: "12px",
                        fontWeight: "600",
                        color: "#bfc2c7",
                      }}
                    >
                      {" "}
                      {t.perDay}
                    </span>
                  </strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FLEET */}
      <section
        style={{
          background: "#f5f5f5",
          padding: "90px 0",
        }}
      >
        <div style={sectionStyle}>
          <div
            style={{
              maxWidth: "750px",
              marginBottom: "45px",
            }}
          >
            <p
              style={{
                margin: "0 0 10px",
                color: "#777",
                fontSize: "12px",
                fontWeight: "900",
                letterSpacing: "2px",
              }}
            >
              {t.fleetLabel}
            </p>

            <h2
              style={{
                margin: "0 0 16px",
                fontSize: "clamp(36px, 5vw, 54px)",
                lineHeight: "1.05",
                letterSpacing: "-2px",
              }}
            >
              {t.fleetTitle}
            </h2>

            <p
              style={{
                margin: 0,
                color: "#666",
                fontSize: "17px",
                lineHeight: "1.7",
              }}
            >
              {t.fleetDescription}
            </p>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns:
                "repeat(auto-fit, minmax(280px, 1fr))",
              gap: "22px",
            }}
          >
            {featuredCars.map((car) => (
              <article
                key={car.id}
                style={{
                  background: "#ffffff",
                  borderRadius: "20px",
                  overflow: "hidden",
                  border: "1px solid #e7e7e7",
                  boxShadow: "0 8px 28px rgba(0,0,0,0.05)",
                }}
              >
                <Link to={`/cars/${car.id}`}>
                  <div
                    style={{
                      height: "220px",
                      background: "#e8e8e8",
                      overflow: "hidden",
                    }}
                  >
                    {car.images && car.images.length > 0 ? (
                      <img
                        src={car.images[0]}
                        alt={car.name}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    ) : (
                      <div
                        style={{
                          height: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#888",
                          fontWeight: "700",
                        }}
                      >
                        {language === "sq"
                          ? "Foto së shpejti"
                          : "Photo coming soon"}
                      </div>
                    )}
                  </div>
                </Link>

                <div style={{ padding: "19px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      gap: "15px",
                    }}
                  >
                    <div>
                      <h3
                        style={{
                          margin: 0,
                          fontSize: "19px",
                        }}
                      >
                        {car.name}
                      </h3>

                      <div
                        style={{
                          marginTop: "5px",
                          color: "#888",
                          fontSize: "12px",
                        }}
                      >
                        {t.car} #{car.id}
                      </div>
                    </div>

                    <div
                      style={{
                        textAlign: "right",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <strong style={{ fontSize: "21px" }}>
                        €{car.price}
                      </strong>

                      <div
                        style={{
                          color: "#777",
                          fontSize: "11px",
                        }}
                      >
                        {t.perDay}
                      </div>
                    </div>
                  </div>

                  <p
                    style={{
                      margin: "14px 0 18px",
                      color: "#666",
                      fontSize: "13px",
                    }}
                  >
                    {car.engine} • {car.transmission} •{" "}
                    {car.category}
                  </p>

                  <Link
                    to={`/cars/${car.id}`}
                    style={{
                      display: "block",
                      padding: "12px",
                      textAlign: "center",
                      borderRadius: "11px",
                      background: "#111317",
                      color: "#ffffff",
                      fontWeight: "900",
                      fontSize: "14px",
                    }}
                  >
                    {t.viewCar}
                  </Link>
                </div>
              </article>
            ))}
          </div>

          <div
            style={{
              marginTop: "34px",
              textAlign: "center",
            }}
          >
            <Link
              to="/cars"
              style={{
                display: "inline-block",
                padding: "14px 22px",
                border: "1px solid #d4d4d4",
                background: "#ffffff",
                borderRadius: "13px",
                fontWeight: "900",
              }}
            >
              {t.viewAll}
            </Link>
          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section
        style={{
          background: "#ffffff",
          padding: "90px 0",
        }}
      >
        <div style={sectionStyle}>
          <div
            style={{
              textAlign: "center",
              maxWidth: "700px",
              margin: "0 auto 45px",
            }}
          >
            <p
              style={{
                margin: "0 0 10px",
                color: "#777",
                fontSize: "12px",
                fontWeight: "900",
                letterSpacing: "2px",
              }}
            >
              {t.whyLabel}
            </p>

            <h2
              style={{
                margin: 0,
                fontSize: "clamp(34px, 5vw, 50px)",
                letterSpacing: "-2px",
              }}
            >
              {t.whyTitle}
            </h2>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns:
                "repeat(auto-fit, minmax(220px, 1fr))",
              gap: "18px",
            }}
          >
            {[
              {
                number: "01",
                title: t.step1Title,
                text: t.step1Text,
              },
              {
                number: "02",
                title: t.step2Title,
                text: t.step2Text,
              },
              {
                number: "03",
                title: t.step3Title,
                text: t.step3Text,
              },
              {
                number: "04",
                title: t.step4Title,
                text: t.step4Text,
              },
            ].map((item) => (
              <div
                key={item.number}
                style={{
                  padding: "25px",
                  border: "1px solid #e8e8e8",
                  borderRadius: "18px",
                  background: "#fafafa",
                }}
              >
                <span
                  style={{
                    display: "block",
                    marginBottom: "35px",
                    color: "#999",
                    fontSize: "13px",
                    fontWeight: "900",
                  }}
                >
                  {item.number}
                </span>

                <h3
                  style={{
                    margin: "0 0 10px",
                    fontSize: "19px",
                  }}
                >
                  {item.title}
                </h3>

                <p
                  style={{
                    margin: 0,
                    color: "#6f6f6f",
                    fontSize: "14px",
                    lineHeight: "1.65",
                  }}
                >
                  {item.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* BENEFITS */}
      <section
        style={{
          background: "#eeeeee",
          padding: "90px 0",
        }}
      >
        <div style={sectionStyle}>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "50px",
              alignItems: "center",
            }}
          >
            <div style={{ flex: "1 1 420px" }}>
              <p
                style={{
                  margin: "0 0 10px",
                  color: "#777",
                  fontSize: "12px",
                  fontWeight: "900",
                  letterSpacing: "2px",
                }}
              >
                {t.travelLabel}
              </p>

              <h2
                style={{
                  margin: "0 0 20px",
                  fontSize: "clamp(36px, 5vw, 54px)",
                  lineHeight: "1.05",
                  letterSpacing: "-2px",
                }}
              >
                {t.travelTitle1}
                <br />
                {t.travelTitle2}
              </h2>

              <p
                style={{
                  margin: "0 0 28px",
                  maxWidth: "560px",
                  color: "#666",
                  fontSize: "16px",
                  lineHeight: "1.75",
                }}
              >
                {t.travelDescription}
              </p>

              <Link
                to="/booking"
                style={{
                  display: "inline-block",
                  padding: "15px 21px",
                  borderRadius: "12px",
                  background: "#111317",
                  color: "#ffffff",
                  fontWeight: "900",
                }}
              >
                {t.findCar}
              </Link>
            </div>

            <div
              style={{
                flex: "1 1 420px",
                display: "grid",
                gridTemplateColumns:
                  "repeat(auto-fit, minmax(180px, 1fr))",
                gap: "14px",
              }}
            >
              {[
                [t.benefitVehicles, t.benefitVehiclesText],
                [t.benefitSupport, t.benefitSupportText],
                [t.benefitPricing, t.benefitPricingText],
                [t.benefitBooking, t.benefitBookingText],
              ].map(([title, text]) => (
                <div
                  key={title}
                  style={{
                    background: "#ffffff",
                    padding: "24px",
                    borderRadius: "18px",
                    minHeight: "160px",
                  }}
                >
                  <strong
                    style={{
                      display: "block",
                      marginBottom: "10px",
                      fontSize: "18px",
                    }}
                  >
                    {title}
                  </strong>

                  <span
                    style={{
                      color: "#777",
                      fontSize: "14px",
                      lineHeight: "1.6",
                    }}
                  >
                    {text}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* FINAL CTA */}
      <section
        style={{
          padding: "90px 0",
          background: "#111317",
          color: "#ffffff",
        }}
      >
        <div
          style={{
            ...sectionStyle,
            textAlign: "center",
          }}
        >
          <p
            style={{
              margin: "0 0 12px",
              color: "#92979e",
              fontSize: "12px",
              fontWeight: "900",
              letterSpacing: "2px",
            }}
          >
            {t.readyLabel}
          </p>

          <h2
            style={{
              margin: "0 auto 20px",
              maxWidth: "800px",
              fontSize: "clamp(38px, 6vw, 62px)",
              lineHeight: "1.05",
              letterSpacing: "-2px",
            }}
          >
            {t.readyTitle}
          </h2>

          <p
            style={{
              margin: "0 auto 30px",
              maxWidth: "570px",
              color: "#999ea5",
              fontSize: "16px",
              lineHeight: "1.7",
            }}
          >
            {t.readyDescription}
          </p>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexWrap: "wrap",
              gap: "12px",
            }}
          >
            <Link
              to="/booking"
              style={{
                padding: "15px 23px",
                background: "#ffffff",
                color: "#111317",
                borderRadius: "12px",
                fontWeight: "900",
              }}
            >
              {t.checkAvailability}
            </Link>

            <a
              href={`https://wa.me/${whatsappNumber}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                padding: "15px 23px",
                border: "1px solid rgba(255,255,255,0.18)",
                color: "#ffffff",
                borderRadius: "12px",
                fontWeight: "900",
              }}
            >
              {t.whatsapp}
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;